module.exports = __webpack_public_path__ + "img/approve-selected.ad059a15.svg";